import request from '@/utils/request'

export function queryItemDetail(data) {
  return request({
    url: '/api/mitmdtlp/queryItemDetail',
    method: 'post',
    data,
  })
}
